import { NavLink } from "react-router-dom";
import { navTab } from "./navData";
import { useState, useRef } from "react";
import { FaChevronLeft } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";

function OurOffers() {
  const offerList = useRef();
  const leftArrowContainer = useRef();
  const rightArrowContainer = useRef();

  const [visibleLeft, setVisibleLeft] = useState("hidden");
  const [visibleRight, setVisibleRight] = useState("flex");

  const manageIcons = () => {
    if (offerList.current.scrollLeft >= 20) {
      setVisibleLeft("flex");
    } else {
      setVisibleLeft("hidden");
    }

    let maxScrollValue =
      offerList.current.scrollWidth - offerList.current.clientWidth - 20;

    if (offerList.current.scrollLeft >= maxScrollValue) {
      setVisibleRight("hidden");
    } else {
      setVisibleRight("flex");
    }
  };

  const manageLeftArrow = () => {
    offerList.current.scrollLeft -= 80;
    manageIcons();
  };
  const manageRightArrow = () => {
    offerList.current.scrollLeft += 80;
    manageIcons();
  };

  const manageScrollList = () => {
    manageIcons();
  };

  return (
    <>
      <div className="hidden justify-center h-[33px] items-center relative truncate bg-[#464957] text-white sm:flex">
        <div
          ref={leftArrowContainer}
          onClick={manageLeftArrow}
          className={`leftArrow w-[50px] h-[100%] ${visibleLeft} justify-start items-center absolute top-0 left-0 bg-gradient-to-r from-[#464957] xl:hidden`}
        >
          <FaChevronLeft className="w-7 h-7 rounded-full hover:bg-[#acacac89] cursor-pointer p-[5px]" />
        </div>

        <ul
          ref={offerList}
          onScroll={manageScrollList}
          className="flex space-x-5 text-[15px] font-display font-medium overflow-x-scroll scroll-smooth px-9 no-scrollbar"
        >
          {navTab.map((names, index) => {
            return (
              <li key={index}>
                <NavLink
                  to={names.link}
                  className={(e) => {
                    return e.isActive ? "text-[#FFE14D]" : undefined;
                  }}
                >
                  {names.name}
                </NavLink>
              </li>
            );
          })}
        </ul>

        <div
          ref={rightArrowContainer}
          onClick={manageRightArrow}
          className={`rightArrow ${visibleRight} w-[50px] h-[100%] items-center absolute top-0 right-0 justify-end bg-gradient-to-l from-[#464957] min-[1220px]:hidden`}
        >
          <FaChevronRight className="w-7 h-7 rounded-full hover:bg-[#acacac89] cursor-pointer p-[5px]" />
        </div>
      </div>
    </>
  );
}

export default OurOffers;
